<template>
  <v-card>
    <v-toolbar dark :color="enterpriseColor">
      <v-btn icon dark @click="onCloseDesktopMode">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{$t('desktopMode.title')}}</v-toolbar-title>
      <div class="flex-grow-1"></div>
      <v-toolbar-items>
        <v-btn dark text @click="handleRestoreDesktopMode">{{$t('common.restore')}}</v-btn>
        <v-btn dark text @click="handleSaveDesktopMode">{{$t('common.save')}}</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-layout
      wrap
      style="padding: 50px"
      v-if="!hideTotem"
    >
      <v-flex
        xs4
      >
        <v-checkbox v-model="totemMenuImportant" :label="`${$t('common.totemMenuImportant')}`" />
      </v-flex>
      <v-flex
        xs8
      >
        <select-image
          v-if="totemMenuImportant"
          v-model="totemMenuImportantImage"
          :isFullWidth="false"
          :enterpriseID="enterpriseID"
          :imageOld='totemMenuImportantImage'
          :label="`${$t('common.totemMenuImportantImage')}:`"
          style="margin-left:0px;margin-top:15px;margin-right: 0px;"
          width="100px"
        />
      </v-flex>
    </v-layout> 
    <table
      v-if="!menu.IsMenuWithSubmenu"
      class="table-main"
      cellspacing="0"
      style="z-index:102"
    >
      <tr>
        <td
          class="simulation"
        >
          <div
            :style="{ 
              'background-color': !menu.isSecundary ? BGColor : BGColorSecundary, 
              'color': !menu.isSecundary ? Color : ColorSecundary, 
              'font-family': !menu.isSecundary ? Font : FontSecundary, 
              'font-size': !menu.isSecundary ? FontSize : FontSizeSecundary,
              'padding': !menu.isSecundary ? '20px 10px 20px 10px !important' : '10px 40px 10px 40px !important'
            }"
            style="boder: 1px solid #000000;"
          >
            <center>
              {{name}}
              <v-btn style="padding:0;min-width:0px;" dark text @click="handleMenuChangeHideDesktop()"><v-icon :style="{ 'color': hideDesktop ? 'red' : 'green' }">mdi-monitor</v-icon></v-btn>
              <v-btn style="padding:0;min-width:0px;" dark text @click="handleMenuChangeHideMobile()"><v-icon :style="{ 'color': hideMobile ? 'red' : 'green' }">mdi-cellphone</v-icon></v-btn>
              <v-btn style="padding:0;min-width:0px;" dark text @click="handleMenuChangeHideTotem()"><v-icon :style="{ 'color': hideTotem ? 'red' : 'green' }">mdi-cellphone-dock</v-icon></v-btn>              
            </center>
          </div>
          <draggable class="list-group" :list="ViewDesktop.ContentFree" group="people" 
            @change="handleDraggable"
            style="border: 1px solid #000000;min-height:100px;"
          >
            <div
              class="list-group-item"
              v-for="(content) in ViewDesktop.ContentFree"
              :key="content.ID"
              style="border: 1px solid #ddd;background-color: #fff; padding: 10px;cursor: pointer;"
            >
              <!-- <div style="position:absolute; width:350px;text-align:right;z-index:10">
                <v-btn dark text @click="handleChangeHideDesktop(content.ID)"><v-icon :style="{ 'color': content.HideDesktop ? 'red' : 'green' }">mdi-monitor</v-icon></v-btn>
                <v-btn dark text @click="handleChangeHideMobile(content.ID)"><v-icon :style="{ 'color': content.HideMobile ? 'red' : 'green' }">mdi-cellphone</v-icon></v-btn>
              </div> -->
              <div style="position:relative; width:350px;">
                <v-checkbox
                  hide-details
                  style="float:left;margin:0;"
                  multiple
                  :value="content"
                  v-model="multiSelected"
                />
                <v-btn style="padding:0;min-width:0px;" dark text @click="handleChangeHideDesktop(content.ID, false)"><v-icon :style="{ 'color': content.HideDesktop ? 'red' : 'green' }">mdi-monitor</v-icon></v-btn>
                <v-btn style="padding:0;min-width:0px;" dark text @click="handleChangeHideMobile(content.ID, false)"><v-icon :style="{ 'color': content.HideMobile ? 'red' : 'green' }">mdi-cellphone</v-icon></v-btn>
                <v-btn style="padding:0;min-width:0px;" dark text @click="handleChangeHideTotem(content.ID, false)"><v-icon :style="{ 'color': content.HideTotem ? 'red' : 'green' }">mdi-cellphone-dock</v-icon></v-btn>
              
                <v-icon>mdi-cursor-move</v-icon> {{ $t(`menuType.${getMenuType(content.Type).name}`) }} <content-name v-if="content.Type === 27" :id="content.ID" :locale="locale" />
              </div>
            </div>
          </draggable>
          <v-btn
            v-if="ViewDesktop.ContentFree && ViewDesktop.ContentFree.length > 0"
            @click="() => { multiSelected = ViewDesktop.ContentFree}"
          >
            <v-icon left>mdi-checkbox-multiple-outline</v-icon> todos
          </v-btn>
        </td>
        <td id="mainForm" v-resize="onResize" style="padding-top:15px;">
          <v-layout
            wrap
          >
            <v-flex xs1/>
            <v-flex xs1/>
            <v-flex
              xs1
              v-for="(btn) in btns"
              :key="btn.id"
            >
              <center>
                <v-img
                  :src="btn.image"
                  width="50px"
                  @click="handleAddRow(btn)"
                />
              </center>
            </v-flex>
          </v-layout>
          <v-layout
            wrap
            v-for="(row, indexRows) in ViewDesktop.Rows"
            :key="`rows${indexRows}`"
          >
            <v-flex
              xs11
            >
              <v-layout
                wrap
              >
                <v-flex
                  v-for="(column, index) in row.Columns"
                  :key="`${indexRows}flex${index}`"
                  v-bind="{ [column.Type]: true }"
                >
                  <v-btn
                    @click="handleMoveContent(column)"
                  >
                    <v-icon>mdi-arrow-down-bold-box-outline</v-icon>
                  </v-btn>
                  <draggable class="list-group" :list="column.Contents" group="people" 
                    @change="handleDraggable"
                    style="background-color: #CCC;
                            margin: 5px;border: 1px solid #cccccc;
                            min-height: 150px;"
                    :key="`${row.ID}flex${index}Drag`"
                  >
                    <div
                      class="list-group-item"
                      v-for="(content) in column.Contents"
                      :key="content.ID"
                      style="border: 1px solid #ddd;background-color: #fff; padding: 10px;cursor: pointer;"
                    >
                      
                      <v-btn style="padding:0;min-width:0px;" dark text @click="handleChangeHideDesktop(content.ID, true)"><v-icon :style="{ 'color': content.HideDesktop ? 'red' : 'green' }">mdi-monitor</v-icon></v-btn>
                      <v-btn style="padding:0;min-width:0px;" dark text @click="handleChangeHideMobile(content.ID, true)"><v-icon :style="{ 'color': content.HideMobile ? 'red' : 'green' }">mdi-cellphone</v-icon></v-btn>
                      <v-btn style="padding:0;min-width:0px;" dark text @click="handleChangeHideTotem(content.ID, true)"><v-icon :style="{ 'color': content.HideTotem ? 'red' : 'green' }">mdi-cellphone-dock</v-icon></v-btn>
              
                      <v-icon>mdi-cursor-move</v-icon> {{ $t(`menuType.${getMenuType(content.Type).name}`) }} <content-name v-if="content.Type === 27" :id="content.ID" :locale="locale" />
                    </div>
                  </draggable>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs1>
              <center>
                <v-btn
                  fab
                  dark
                  color="red"
                  small
                  @click="handleDeleteRow(row.ID)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </center>
            </v-flex>
          </v-layout>
        </td>
      </tr>
    </table>
  </v-card>
</template>
<script>
  import {
    mapState
  } from 'vuex'
  import uuidv1 from 'uuid/v1'
  import constants from '@/constants'
  import utils from '@/services/utils'
  import draggable from "vuedraggable"
  import api from '@/services/api'
  import SelectImage from '@/components/SelectImage'
  import ContentName from './ContentName'

  export default {
    components: {
      draggable,
      SelectImage,
      ContentName,
    },
    props: {
      onCloseDesktopMode: {
        type: Function,
        required: true
      },
      menu: {
        type: Object,
        required: true
      },
    },
    data () {
      return {
        multiSelected: [],
        // INI totem
        totemMenuImportant: false,
        totemMenuImportantImage: null,
        hideTotem: false,
        // END totem
        allContent: [],
        hideDesktop: false,
        hideMobile: false,
        btns: [
          {
            id: '1_1',
            image: './img/desktop-view/1_1.png',
            data: [
              {
                Type: 'xs12',
                Contents: []
              }
            ]
          },
          {
            id: '1_2',
            image: './img/desktop-view/1_2.png',
            data: [
              {
                Type: 'xs6',
                Contents: []
              },
              {
                Type: 'xs6',
                Contents: []
              }
            ]
          },
          {
            id: '1_3_2_3',
            image: './img/desktop-view/1_3_2_3.png',
            data: [
              {
                Type: 'xs4',
                Contents: []
              },
              {
                Type: 'xs8',
                Contents: []
              }
            ]
          },
          {
            id: '1_3',
            image: './img/desktop-view/1_3.png',
            data: [
              {
                Type: 'xs4',
                Contents: []
              },
              {
                Type: 'xs4',
                Contents: []
              },
              {
                Type: 'xs4',
                Contents: []
              }
            ]
          },
          {
            id: '1_4',
            image: './img/desktop-view/1_4.png',
            data: [
              {
                Type: 'xs3',
                Contents: []
              },
              {
                Type: 'xs3',
                Contents: []
              },
              {
                Type: 'xs3',
                Contents: []
              },
              {
                Type: 'xs3',
                Contents: []
              }
            ]
          },
          {
            id: '2_3_1_3',
            image: './img/desktop-view/2_3_1_3.png',
            data: [
              {
                Type: 'xs8',
                Contents: []
              },
              {
                Type: 'xs4',
                Contents: []
              }
            ]
          },
          {
            id: '1_4_2_4_1_4',
            image: './img/desktop-view/1_4_2_4_1_4.png',
            data: [
              {
                Type: 'xs3',
                Contents: []
              },
              {
                Type: 'xs6',
                Contents: []
              },
              {
                Type: 'xs3',
                Contents: []
              }
            ]
          },
          {
            id: '1_5_3_5_1_5',
            image: './img/desktop-view/1_5_3_5_1_5.png',
            data: [
              {
                Type: 'xs2',
                Contents: []
              },
              {
                Type: 'xs8',
                Contents: []
              },
              {
                Type: 'xs2',
                Contents: []
              }
            ]
          }
        ],
        ViewDesktop: {
          ContentFree: [],
          Rows: [
            
          ]
        }
      }
    },
    computed: {
      ...mapState('app',['locale', 'BGColor', 'Color', 'Font', 'FontSize', 'BGColorSecundary', 'ColorSecundary', 'FontSecundary', 'FontSizeSecundary']),
      name () {
        return this.menu.Name ? utils.getTranslation (this.menu.Name, this.locale).toUpperCase() : ''
      },
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      }
    },
    mounted () {
      api.getAll(`menus/desktop-view/${this.menu.ID}`, true, 1, 100000, '').then(response => {        
        this.hideDesktop = response.HideDesktop
        this.hideMobile = response.HideMobile
        this.hideTotem = response. HideTotem
        this.totemMenuImportant = response.TotemMenuImportant ? true : false
        this.totemMenuImportantImage = response.TotemMenuImportantImage

        let aux = response && response.contents ? response.contents.map(item => {
          console.log('aaaa', item)
          return ({
            ID: item.ID,
            HideDesktop: item.HideDesktop ? true : false,
            HideMobile: item.HideMobile ? true : false,
            HideTotem: item.HideTotem ? true : false,
            Type: item.Type
          })
        }) : []

        this.allContent = JSON.parse(JSON.stringify(aux))
        const contentFree = aux
        if (response && response.struct) {
          this.ViewDesktop.Rows = JSON.parse(response.struct)
          const rows = JSON.parse(response.struct)
          for (let row of this.ViewDesktop.Rows) {
            for (let column of row.Columns) {
              // column.Contents = column.Contents.filter(x=> x === null)
              for (let content of column.Contents) {

                const auxRow = aux.filter(x=>x.ID === content.ID)
                content = auxRow && auxRow.length > 0 ? auxRow[0] : null
                aux = aux.filter(x => x.ID !== content.ID)            
              } 
            } 
          } 
          // for (let i = 0; i < this.ViewDesktop.Rows.length; i++) {
          //   for (let j = 0; j < this.ViewDesktop.Rows[i].Columns.length; j++) {
          //     this.ViewDesktop.Rows[i].Columns[j].Contents = this.ViewDesktop.Rows[i].Columns[j].Contents.filter(x=> x == null)
          //     for (let k = 0; k < this.ViewDesktop.Rows[i].Columns[j].Contents.length; k++) {
          //       const auxRow = aux.filter(x=>x.ID === this.ViewDesktop.Rows[i].Columns[j].Contents[k].ID)
          //       this.ViewDesktop.Rows[i].Columns[j].Contents[k] = auxRow && auxRow.length > 0 ? auxRow[0] : null
          //       console.log('jjj', this.ViewDesktop.Rows[i].Columns[j].Contents[k])
          //       aux = aux.filter(x=>x.ID !== this.ViewDesktop.Rows[i].Columns[j].Contents[k].ID)            
          //     } 
          //   } 
          // } 
        }

        this.ViewDesktop.ContentFree = aux
      })
    },
    methods: {
      getMenuType (type) {
        const aux = constants.menuType.filter(x => x.id === type)
        return aux.length > 0 ? aux[0] : type
      },
      onResize () {
        this.$store.state.app.mainFormWidth = document.getElementById('mainForm').offsetWidth // window.innerWidth
      },
      handleDraggable (evt) {
        if (evt.moved || evt.added || evt.removed) {
        }
      },
      handleMenuChangeHideDesktop () {
        this.hideDesktop = this.hideDesktop === true ? false : true
      },
      handleMenuChangeHideMobile () {
        this.hideMobile = this.hideMobile === true ? false : true
      },
      handleMenuChangeHideTotem () {
        this.hideTotem = this.hideTotem === true ? false : true
      },
      handleChangeHideTotem (id, isStruct) {
        if (!isStruct) {
          const aux = JSON.parse(JSON.stringify(this.ViewDesktop.ContentFree))
          for (let i = 0; i < aux.length; i++) {
            if (aux[i].ID === id) aux[i].HideTotem = !aux[i].HideTotem
          }
          this.ViewDesktop.ContentFree = aux
        } else {
          // si está asignado a una structura
          const aux = JSON.parse(JSON.stringify(this.ViewDesktop.Rows))
          for (let i = 0; i < aux.length; i++) {
            for (let j = 0; j < aux[i].Columns.length; j++) {
              for (let k = 0; k < aux[i].Columns[j].Contents.length; k++) {
                if (aux[i].Columns[j].Contents[k].ID === id) {
                  aux[i].Columns[j].Contents[k].HideTotem = !aux[i].Columns[j].Contents[k].HideTotem
                }
              }
            }
          }
          this.ViewDesktop.Rows = aux
        }
      },
      handleChangeHideDesktop (id, isStruct) {
        if (!isStruct) {
          const aux = JSON.parse(JSON.stringify(this.ViewDesktop.ContentFree))
          for (let i = 0; i < aux.length; i++) {
            if (aux[i].ID === id) aux[i].HideDesktop = !aux[i].HideDesktop
          }
          this.ViewDesktop.ContentFree = aux
        } else {
          // si está asignado a una structura
          const aux = JSON.parse(JSON.stringify(this.ViewDesktop.Rows))
          for (let i = 0; i < aux.length; i++) {
            for (let j = 0; j < aux[i].Columns.length; j++) {
              for (let k = 0; k < aux[i].Columns[j].Contents.length; k++) {
                if (aux[i].Columns[j].Contents[k].ID === id) {
                  aux[i].Columns[j].Contents[k].HideDesktop = !aux[i].Columns[j].Contents[k].HideDesktop
                }
              }
            }
          }
          this.ViewDesktop.Rows = aux
        }
      },
      handleChangeHideMobile (id, isStruct) {
        if (!isStruct) {
          const aux = JSON.parse(JSON.stringify(this.ViewDesktop.ContentFree))
          for (let i = 0; i < aux.length; i++) {
            if (aux[i].ID === id) aux[i].HideMobile = !aux[i].HideMobile
          }
          this.ViewDesktop.ContentFree = aux
        } else {
          // si está asignado a una structura
          const aux = JSON.parse(JSON.stringify(this.ViewDesktop.Rows))
          for (let i = 0; i < aux.length; i++) {
            for (let j = 0; j < aux[i].Columns.length; j++) {
        console.log('jjjjj', true, id)
              for (let k = 0; k < aux[i].Columns[j].Contents.length; k++) {
                if (aux[i].Columns[j].Contents[k].ID === id) {
                  aux[i].Columns[j].Contents[k].HideMobile = !aux[i].Columns[j].Contents[k].HideMobile
                }
              }
            }
          }
          this.ViewDesktop.Rows = aux
        }
      },
      handleAddRow (btn) {
        const rows = {
          ID: uuidv1(),
          Columns: JSON.parse(JSON.stringify(btn.data))
        }
        this.ViewDesktop.Rows.push(rows)
      },
      handleDeleteRow (id) {
        const aux = this.ViewDesktop.Rows.filter( x => x.ID === id) [0]
        for (let i = 0; i < aux.Columns.length; i++) {
          for (let j = 0; j < aux.Columns[i].Contents.length; j++) {
            this.ViewDesktop.ContentFree.push(aux.Columns[i].Contents[j])
          }
        }
        this.ViewDesktop.Rows = this.ViewDesktop.Rows.filter( x => x.ID !== id)
      },
      handleRestoreDesktopMode () {
        this.ViewDesktop.ContentFree = JSON.parse(JSON.stringify(this.allContent))
        this.ViewDesktop.Rows = []
      },
      handleSaveDesktopMode () {
        const body = {
          rows: this.ViewDesktop.Rows,
          hideValues: []
        }
        body.hideValues.push(...this.ViewDesktop.ContentFree)
        for (let i = 0; i < this.ViewDesktop.Rows.length; i++) {
          for (let j = 0; j < this.ViewDesktop.Rows[i].Columns.length; j++) {
            body.hideValues.push(...this.ViewDesktop.Rows[i].Columns[j].Contents)
          }
        }
        body.HideDesktop = this.hideDesktop
        body.HideMobile = this.hideMobile

        body.HideTotem = this.hideTotem
        body.TotemMenuImportant = this.totemMenuImportant
        body.TotemMenuImportantImage = this.totemMenuImportantImage

        api.addItem(`menus/desktop-view/${this.menu.ID}`, body)
          .then(response => { 
            if (response.status === 200) {
              this.onCloseDesktopMode()
            }
          })
          .catch(error => {
            console.log('error', error)
            this.loading = false
          })
      },
      handleMoveContent (column) {
        column.Contents.push(...this.multiSelected)
        this.ViewDesktop.ContentFree = this.ViewDesktop.ContentFree.filter(x => this.multiSelected.map(item => item.ID).indexOf(x.ID) < 0)
        this.multiSelected = []
      },
    },
  }
</script>
<style lang="scss">
  h1 {
    font-weight: normal;
  }
  .table-main {
    width: 100%;
    min-height: calc(100vh);
    z-index: 110;
  }
  .table-main td {
    vertical-align: top;
  }
  .table-main.body {
    width: auto;
  }
  .simulation {
    width: 360px;
    padding: 0;
  }
  .simulation-content {
    position:fixed;
    width: 360px;
    padding: 0;
    overflow: auto;
    max-height: 100vh;
  }
</style>
